// extracted by mini-css-extract-plugin
module.exports = {"Flex":"About_Flex__DLEqq","Content":"About_Content__ATjLO","Photo":"About_Photo__3d__m"};